import { Outlet } from "react-router-dom";

const Schedules = () => {

  return <Outlet />
}

export default Schedules;